import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';



@Component({
  selector: 'page-add-technology',
  templateUrl: 'add-technology.html'
})
export class AddTechnologyPage {

   // Define FormBuilder /model properties
   public form 			: FormGroup;
   public technologyName 	: any;
   public technologyDescription	: any;
   // Flag to be used for checking whether we are adding/editing an entry
   public isEdited 		: boolean = false;
   // Flag to hide the form upon successful completion of remote operation
   public hideForm 		: boolean = false;
   // Property to help ste the page title
   public pageTitle        	: string;
   // Property to store the recordID for when an existing entry is being edited
   public recordID 		: any 	  = null;
   private baseURI 		: string  = "http://kasstailor.stagnoapps.com/";

   // Initialise module classes
   constructor(public navCtrl 	: NavController,
               public http 	: Http,
               public NP   	: NavParams,
               public fb 	: FormBuilder,
               public toastCtrl : ToastController)
   {

      // Create form builder validation rules
      this.form = fb.group({
         "name"            	 : ["", Validators.required],
         "description"           : ["", Validators.required]
      });
   }



   // Determine whether we adding or editing a record
   // based on any supplied navigation parameters
   ionViewWillEnter()
   {
      this.resetFields();

      if(this.NP.get("record"))
      {
         this.isEdited 		 = true;
         this.selectEntry(this.NP.get("record"));
         this.pageTitle 	 = 'Amend entry';
      }
      else
      {
         this.isEdited 		 = false;
         this.pageTitle 	 = 'Create entry';
      }
   }



   // Assign the navigation retrieved data to properties
   // used as models on the page's HTML form
   selectEntry(item)
   {
      this.technologyName 	 = item.name;
      this.technologyDescription = item.description;
      this.recordID 		 = item.id;
   }



   // Save a new record that has been added to the page's HTML form
   // Use angular 2's http post method to submit the record data
   // to our remote PHP script (note the body variable we have created which
   // supplies a variable of key with a value of create followed by the key/value pairs
   // for the record data
   createEntry(name, description)
   {
      let body   : string	 = "key=create&name=" + name + "&description=" + description,
          type 	 : string	 = "application/x-www-form-urlencoded; charset=UTF-8",
          headers: any		 = new Headers({ 'Content-Type': type}),
          options: any 		 = new RequestOptions({ headers: headers }),
          url 	 : any		 = this.baseURI + "manage-data.php";

      this.http.post(url, body, options)
      .subscribe((data) =>
      {
         // If the request was successful notify the user
         if(data.status === 200)
         {
            this.hideForm 	 = true;
            this.sendNotification(`Congratulations the technology: ${name} was successfully added`);
         }
         // Otherwise let 'em know anyway
         else
         {
            this.sendNotification('Something went wrong!');
         }
      });
   }



   // Update an existing record that has been edited in the page's HTML form
   // Use angular 2's http post method to submit the record data
   // to our remote PHP script (note the body variable we have created which
   // supplies a variable of key with a value of update followed by the key/value pairs
   // for the record data
   updateEntry(name, description)
   {
      let body 		: string = "key=update&name=" + name + "&description=" + description + "&recordID=" + this.recordID,
          type 		: string = "application/x-www-form-urlencoded; charset=UTF-8",
          headers 	: any 	 = new Headers({ 'Content-Type': type}),
          options 	: any 	 = new RequestOptions({ headers: headers }),
          url 		: any 	 = this.baseURI + "manage-data.php";

      this.http.post(url, body, options)
      .subscribe(data =>
      {
         // If the request was successful notify the user
         if(data.status === 200)
         {
            this.hideForm 	=	true;
            this.sendNotification(`Congratulations the technology: ${name} was successfully updated`);
         }
         // Otherwise let 'em know anyway
         else
         {
            this.sendNotification('Something went wrong!');
         }
      });
   }



   // Remove an existing record that has been selected in the page's HTML form
   // Use angular 2's http post method to submit the record data
   // to our remote PHP script (note the body variable we have created which
   // supplies a variable of key with a value of delete followed by the key/value pairs
   // for the record ID we want to remove from the remote database
   deleteEntry()
   {
      let name 		: string	= this.form.controls["name"].value,
          body 		: string 	= "key=delete&recordID=" + this.recordID,
          type 		: string	= "application/x-www-form-urlencoded; charset=UTF-8",
          headers 	: any		= new Headers({ 'Content-Type': type}),
          options 	: any		= new RequestOptions({ headers: headers }),
          url 		: any		= this.baseURI + "manage-data.php";

      this.http.post(url, body, options)
      .subscribe(data =>
      {
         // If the request was successful notify the user
         if(data.status === 200)
         {
            this.hideForm 		= true;
            this.sendNotification(`Congratulations the technology: ${name} was successfully deleted`);
         }
         // Otherwise let 'em know anyway
         else
         {
            this.sendNotification('Something went wrong!');
         }
      });
   }



   // Handle data submitted from the page's HTML form
   // Determine whether we are adding a new record or amending an
   // existing record
   saveEntry()
   {
      let name     	: string	= this.form.controls["name"].value,
          description	: string 	= this.form.controls["description"].value;

      if(this.isEdited)
      {
         this.updateEntry(name, description);
      }
      else
      {
         this.createEntry(name, description);
      }
   }



   // Clear values in the page's HTML form fields
   resetFields() : void
   {
      this.technologyName		= "";
      this.technologyDescription  	= "";
   }



   // Manage notifying the user of the outcome
   // of remote operations
   sendNotification(message)  : void
   {
      let notification = this.toastCtrl.create({
          message 		: message,
          duration 		: 3000
      });
      notification.present();
   }



}


// WEBPACK FOOTER //
// ./src/pages/add-technology/add-technology.ts